import { type HeatmapFormAction } from './heatmapForm.action';
import {
  heatmapFormInitialStyleSet, heatmapFormReset,
} from './heatmapForm.actionCreators';
import { type HeatmapFormState } from './heatmapForm.state';

const heatmapFormInitialState: HeatmapFormState = {
  initialStyle: null,
};

export const heatmapFormReducer = (
  state = heatmapFormInitialState,
  action: HeatmapFormAction
): HeatmapFormState => {
  if (heatmapFormReset.match(action)) {
    return heatmapFormInitialState;
  }

  if (heatmapFormInitialStyleSet.match(action)) {
    return { ...state, initialStyle: action.payload.style };
  }

  return state;
};
